import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_AKTORER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/aktorer`;
export const POST_AKTOR_URL = `${ILEGGELSE_SERVICE_BASE_URL}/aktorer`;
export const PUT_AKTOR_URL = (id) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/aktorer/${id}`;
